import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** Top line of a server list card: identity on the left, actions on the right. */
const CardHeaderRow = ({ sx, ...rest }: BoxProps) => (
	<Box
		sx={combineSx(
			{
				display: 'flex',
				gap: 200,
				justifyContent: 'space-between',
				alignItems: 'start',
				minWidth: 0,
			},
			sx,
		)}
		{...rest}
	/>
);

export default CardHeaderRow;
